import React from 'react';
import { Space, Spin, Typography } from 'antd';

const { Text } = Typography;

import { getUserDate } from '../../utils/date-utils';

const CalendarTimeZoneInfo = ({ timeZoneInfo }) => {
  return (
    <Space direction="horizontal">
      <Text>
        Current Time Zone: <b>{timeZoneInfo && timeZoneInfo.timeZoneName ? timeZoneInfo.timeZoneName : <Spin size="small" />}</b>
      </Text>

      <Text>
        Date:{' '}
        <b>
          {timeZoneInfo && timeZoneInfo.baseUtcOffsetHours ? getUserDate(timeZoneInfo.baseUtcOffsetHours, 'MMM DD, YYYY') : <Spin size="small" />}
        </b>
      </Text>

      <Text>
        Time:{' '}
        <b>{timeZoneInfo && timeZoneInfo.baseUtcOffsetHours ? getUserDate(timeZoneInfo.baseUtcOffsetHours, 'hh:mm A') : <Spin size="small" />}</b>
      </Text>
    </Space>
  );
};

export default CalendarTimeZoneInfo;
